// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguagesDropdown_container__Y71K6","active":"LanguagesDropdown_active__Zd_Px","menu":"LanguagesDropdown_menu__FvS2E","title":"LanguagesDropdown_title__ZfUoo"};